"use client";

import ProductCardLoading from "@/components/entities/product-card/loading-card";
import { useCollectionData } from "../../../hooks/useCollectionData";
import ProductCard from "@/components/entities/product-card";
import Pager from "@/components/entities/pager";
import { useStore } from "@/hooks/system/useStore";
import S from "./index.module.scss";

const ProductsList = () => {
  const {
    products: { loading, products },
  } = useCollectionData();

  const { selectedFilters, setSelectedFilters } = useStore("collection");

  const pageHandler = (page: number) => {
    setSelectedFilters({ page_number: page });
  };

  const renderList = () => {
    if (loading) {
      return new Array(12).fill({ id: 0 }).map((_, idx) => <ProductCardLoading key={idx} />);
    }

    return products?.products.map(product => <ProductCard key={product.id} product={product} />);
  };

  return (
    <>
      <div className={S.productsList}>{renderList()}</div>
      {products && (
        <Pager
          activePageNumber={selectedFilters.page_number || 1}
          total={products.total}
          activePageSize={products.count || 12}
          onPageChangeHandler={pageHandler}
        />
      )}
    </>
  );
};

export default ProductsList;
